import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import Master from "../Master";
import { useHistory } from "react-router-dom";
import {
  getRequestInAssets as getRequestOnEnterprise,
  postRequestInAssets as postRequest,
  putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import { getRequest } from "services/axiosBaseClient";

import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import moment from "moment";
import notificationService from "services/notification.service";
import jwt_decode from "jwt-decode";
import QRCodeView from "../../components/QRcode/QRCode";

var id = undefined;
var action = null;
var title = "Add Vehicle";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var enterpriseName = "";
var utcTime;
const currentYear = new Date().getFullYear();
const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
const unique = range(currentYear, currentYear - 20, -1);

const AddVehicleForm = (props) => {
  const initialFormValues = {
    regNo: "",
    // status: 0,
    makeId: -1,
    modelId: -1,
    model: "",
    year: null,
    enterprise: "",
    vehicleType: null,
    originSiteId: null,
  };
  var test;

  const [makeList, setMakeList] = useState([]);
  const [makeName, setMakeName] = useState("");
  const [modelYearList, setModelYearList] = useState([]);
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [sitesListLastest, setSitesListLastest] = useState([]);

  const history = useHistory();

  const getVehicleDataByID = async (id, enterprise) => {
    await getRequestOnEnterprise(
      `getVehicleById?id=${id}&enterprise=${enterprise}`
    )
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const patchForm = (data) => {
    getMakes(data.enterprise);
    getModels(data.makeId, data.enterprise, data.modelId);
    const tempDate = data.warrantyStartDate;
    const formatingDate = moment(tempDate).format("ddd MMM DD YYYY hh:mm:ss a");
    const srtingDate = new Date(formatingDate).toISOString();

    setFormValues({
      regNo: data.regNo?.trim(),
      makeId: data.makeId,
      modelId: data.modelId,
      year: data.year,
      enterprise: data.enterprise,
      id: data.id,
      status: data.status,
      enterprise: data.enterprise,
      originSiteId: data.originSiteId,
      vehicleType: data.vehicleType,
    });

    window.scrollTo({ top: 0 });
  };

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Assets",
      state: { table: 6, compomentRenderType: "view" },
    });
  };

  const getMakes = useCallback(async (enterprise) => {
    await getRequest("make/get?type=VEHICLE&enterprise=" + enterprise)
      .then((res) => {
        if (res.data != null) {
          setMakeList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getModels = useCallback(async (id, enterprise, modelid) => {
    await getRequest("model/get?enterprise=" + enterprise + "&makeId=" + id)
      .then((res) => {
        if (res && res.data) {
          setModelYearList(res.data);
          // if (res?.data) {
          //   setSelectedModelYearList(res.data.filter((x) => x.id === modelid));
          // }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (e.target.name === "regNo") {
      setFormValues({ ...formValues, [name]: value.replace(/[^a-zA-Z0-9 ]+/g, ""), });
    }

    if (name === "makeId") {
      if (Number(value) === -1) {
        return setFormValues({
          ...formValues,
          makeId: -1,
          make: "",
          modelId: -1,
          model: "",
          year: null,
        });
      } else {
        getModels(value, formValues.enterprise);
        formValues.makeId = value;
        makeList.find((data) => {
          if (data.id == value) {
            formValues.make = data.name;
            setMakeName(data.name);
          }
        });
        setFormValues({ ...formValues, modelId: -1, model: "", year: null });
      }
    }

    // if (name === "modelName") {
    //   setSelectedModelYearList(modelYearList.filter((x) => x.name === value));
    // }

    if (name === "modelId") {
      if (Number(value) === -1) {
        return setFormValues({
          ...formValues,
          modelId: -1,
          model: "",
          year: null,
        });
      } else {
        setFormValues({
          ...formValues,
          model: "",
          modelId: Number(value),
          year: null,
        });
        modelYearList.find((data) => {
          if (data.id == value) {
            formValues.modelId = data.id;
            setFormValues({
              ...formValues,
              model: data.name,
              modelId: Number(data.id),
              // makeId: data.makeId,
              make: makeName,
              year: null,
            });
          }
        });
      }
    }
    if (name === "originSiteId") {
      const st = sitesListLastest.find((x) => {
        return value == x.siteId;
      });

      setFormValues({ ...formValues, originSiteId: st?.siteId? st?.siteId : null });
    }
    if (name === "enterprise") getMakes(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);
    if (Object.values(result).every((x) => x === "")) {
      if (action === "Update") {
        try {
          putRequest("updateVehicle", JSON.stringify(formValues))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 6, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          postRequest("addVehicle", JSON.stringify(formValues))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Assets",
                  state: { table: 6 },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    let regex = new RegExp(
      /^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$/
    );
    const errors = {};

    if (!formValues.regNo?.replace(/\s/g, "").length) {
      errors.regNo = "Vehicle Registration Number is required!";
      // } else   if (!regex.test(formValues.regNo)) {
      //   errors.regNo =
      //     "Please enter a valid Vehicle Number !";
      // } else if (!/^[ A-Za-z0-9-_./&']*$/i.test(formValues.regNo)) {
      //   errors.regNo =
      //     "/-_&'. are the only allowed special characters";
    } else {
      errors.regNo = "";
    }
    if (!formValues.makeId || formValues.makeId === -1) {
      errors.makeId = "Make is required!";
    } else {
      errors.makeId = "";
    }

    if (!formValues.modelId || formValues.modelId === -1) {
      errors.modelId = "Model is required!";
    } else {
      errors.modelId = "";
    }
    
    if (
      !formValues.vehicleType ||
      formValues.vehicleType == "null" ||
      formValues.vehicleType == null
    ) {
      errors.vehicleType = "Vehicle Type is required!";
    } else {
      errors.vehicleType = "";
    }

    if (!formValues.enterprise || formValues.enterprise === "-1") {
      errors.enterprise = "Enterprise name is required!";
    } else {
      errors.enterprise = "";
    }
    // if (!formValues.status || formValues.status === "-1") {
    //   errors.status = "Battery status is required!";
    // } else {
    //   errors.status = "";
    // }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    enterpriseName = decodedToken.group[0];
    formValues.enterprise = enterpriseName;

    getMakes(enterpriseName);
    getSite();
    // getModels(enterpriseName);
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Vehicle";
      readOnlyField = true;
      onlyView = false;
      getVehicleDataByID(id, enterpriseName);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Vehicle";
      onlyView = true;
      getVehicleDataByID(id, enterpriseName);
    } else {
      onlyView = false;
      title = "Add Vehicle";
      action = "Submit";
    }
  }, []);

  const getSite = useCallback(async () => {
    await getRequestOnEnterprise(`bss/siteInfo`)
      .then((res) => {
        if (res?.data?.count >= 1) {
          setSitesListLastest(res.data.sites);
          //props.assetCount(()=>res.data.count);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);
  return (
    <>
      <h2
        id="AddVehicle_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        {"Vehicle"}
      </h2>

      <div
        id="AddVehicle_Form_layout"
        className={cn(styles.group, styles.group_layout)}
      >
        <form id="AddVehicle_Form">
          <div
            id="AddVehicle_Form_layout1"
            className={cn(styles.flex3, styles.flex3_layout)}
          >
            <h3
              id="AddVehicle_Form_title"
              className={cn(styles.subtitle, styles.subtitle_layout)}
            >
              {title}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div
              id="AddVehicle_Form_row1"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddVehicle_VehicleRegNo_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddVehicle_VehicleRegNo"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_VehicleRegNo_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Vehicle Registration Number*"}
                  </div>
                  <input
                    id="AddVehicle_VehicleRegNo_input"
                    name="regNo"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.regNo}
                    onChange={handleChange}
                    disabled={onlyView}
                    maxLength={16}
                  />
                </div>
                <p>{formErrors.regNo}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddVehicle_EnterpriseName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddVehicle_EnterpriseName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_EnterpriseName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Enterprise Name*"}
                  </div>
                  <input
                    id="AddVehicle_EnterpriseName_input"
                    name="enterprise"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.enterprise}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                <p>{formErrors.enterprise}</p>
              </div>
            </div>

            <div
              id="AddVehicle_Form_row2"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddVehicle_Make_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddVehicle_Make"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_Make_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Make*"}
                  </div>
                  <select
                    id="AddVehicle_Make_select"
                    name="makeId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.makeId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={-1}>Select Make</option>
                    {makeList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.makeId}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddVehicle_Model_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddVehicle_Model"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_Model_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Model*"}
                  </div>
                  <select
                    id="AddVehicle_Model_select"
                    name="modelId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.modelId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={-1}>Select Model</option>
                    {modelYearList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.modelId}</p>
              </div>
            </div>

            <div
              id="AddVehicle_Form_row3"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddVehicle_Year_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddVehicle_Year"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_Year_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Year"}
                  </div>
                  <select
                    id="AddVehicle_Year_select"
                    name="year"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.year}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={null}>Select Year</option>
                    {unique.map((val) => {
                      return <option value={val}>{val}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.year}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="AddVehicle_Site_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddVehicle_Site"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_Site_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Site"}
                  </div>

                  <select
                    id="AddVehicle_Site_select"
                    name="originSiteId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.originSiteId}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={null}>Select Site</option>
                    {sitesListLastest.map((obj) => {
                      return <option value={obj.siteId}>{obj.siteName}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.originSiteId}</p>
              </div>
            </div>
            <div
              id="AddVehicle_Form_row4"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddVehicle_VehicleType_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddVehicle_VehicleType"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddVehicle_VehicleType_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Vehicle Type*"}
                  </div>

                  <select
                    id="AddVehicle_VehicleType_select"
                    name="vehicleType"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.vehicleType}
                    onChange={handleChange}
                    disabled={onlyView}
                  >
                    <option value={"null"}>Select Vehicle Type</option>
                    <option value={"2W"}>Two Wheeler</option>
                    <option value={"3W"}>Three Wheeler</option>
                    <option value={"4W"}>Four Wheeler</option>
                  </select>
                </div>
                <p>{formErrors.vehicleType}</p>
              </div>
              {/* <div className={cn(styles.flex2_item)}>
                <div className={cn(styles.block3, styles.block3_layout)}>
                  <div
                    className={cn(
                      styles.text_body,
                      styles.text_body_layout
                    )}
                  >
                    {"Vehicle Status*"}
                  </div>
                  <select
                    name="status"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.status}
                    onChange={handleChange}
                    disabled={onlyView}
                    type="select"
                  >
                    <option value="" selected>Select Status</option>
                    <option value={1}>Active</option>
                    <option value={0}>Inactive</option>
                  </select>
                </div>
                <p>{formErrors.status}</p>
              </div> */}
              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div>
            </div>
            {onlyView && (
                    <div
                      id="AddVehicle_Form_row7"
                      className={cn(styles.flex2, styles.flex2_layout)}
                    >
                      <div
                        id="AddVehicle_QRCode_block"
                        className={cn(styles.flex2_item)}
                      >
                        <div
                          id="AddVehicle_QRCode"
                          className={cn(styles.block3, styles.block3_layout)}
                        >
                          <div
                            id="AddVehicle_QRCode_layout"
                            className={cn(
                              styles.text_body,
                              styles.text_body_layout
                            )}
                          >
                            {"QR Code"}
                          </div>
                          <QRCodeView value={formValues.regNo} visibility={true} />
                        </div>
                        {/* <p>{formErrors.batteryModel}</p> */}
                      </div>
                    </div>
                  )}
            <div
              id="AddVehicle_Button_container"
              className={cn(styles.flex9, styles.flex9_layout)}
            >
              <div
                id="AddVehicle_Button_container1"
                className={cn(styles.flex9_item)}
                onClick={routeChange}
              >
                <div
                  id="AddVehicle_BackButton_background"
                  onClick={reset}
                  className={cn(styles.block7, styles.block7_layout)}
                  style={onlyView ? { left: "20px" } : { left: "0px" }}
                >
                  <h5
                    id="AddVehicle_BackButton_title"
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                    style={{ textAlign: "center" }}
                  >
                    {onlyView ? "Back" : "Cancel"}
                  </h5>
                </div>
              </div>

              <div className={cn(styles.flex9_spacer)} />
              {!onlyView ? (
                <div
                  id="AddVehicle_SubmitButton"
                  className={cn(styles.flex9_item)}
                >
                  <div
                    id="AddVehicle_SubmitButton_background"
                    className={cn(styles.block9, styles.block9_layout)}
                    onClick={handleSubmit}
                    style={{
                      backgroundColor: "#315CBB",
                      position: "absolute",
                      height: "45px",
                      width: "120px",
                      borderRadius: "5px",
                    }}
                  >
                    <div
                      id="AddVehicle_SubmitButton_title"
                      className={cn(
                        styles.highlights2,
                        styles.highlights2_layout
                      )}
                    >
                      {action}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
export default function AddVehicle(props) {
  return (
    <>
      <Master opts={props} screen={AddVehicleForm} showStatus={false} />
    </>
  );
}

AddVehicle.inStorybook = true;
